// src/components/marketing/Hero.jsx
import React from "react";
import { Link } from "react-router-dom";

const Hero = ({
  title = "",
  subtitle = "",
  ctaText = "",
  ctaLink = "",
  backgroundImage = "",
  height = "full",
}) => {
  const heightClass = height === "full" ? "h-screen" : "h-[300px]";

  const videoSrc = `${process.env.PUBLIC_URL}/hero.mp4`;

  const backgroundStyle = backgroundImage
    ? {
        background: `url(${String(backgroundImage)}) center bottom no-repeat`,
        backgroundSize: height === "full" ? "contain" : "cover",
      }
    : {
        backgroundColor: "#7A5FB6",
        backgroundSize: height === "full" ? "contain" : "cover",
      };

  return (
    <header
      className={`${heightClass} flex items-center justify-center text-center text-white px-5 relative mt-[70px] overflow-hidden`}
      style={backgroundStyle}
    >
      {/* Video background */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
      >
        <source src={videoSrc} type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-purple-800 bg-opacity-45"></div>

      {/* Content */}
      <div className="relative z-10 max-w-3xl">
        {title && typeof title === "string" && (
          <h1 className="text-4xl md:text-5xl leading-tight mb-7 font-['Lexend_Deca'] text-white">
            {String(title)}
          </h1>
        )}

        {subtitle && typeof subtitle === "string" && (
          <p className="text-lg md:text-xl mb-7">{String(subtitle)}</p>
        )}

        {ctaText &&
          ctaLink &&
          typeof ctaText === "string" &&
          typeof ctaLink === "string" && (
            <Link
              to={String(ctaLink)}
              className="inline-block bg-cream-100 text-purple-800 font-semibold text-base px-8 py-3 rounded-lg no-underline tracking-wider transition-all duration-250 hover:bg-white hover:shadow-lg hover:-translate-y-0.5"
            >
              {String(ctaText)}
            </Link>
          )}
      </div>
    </header>
  );
};

export default Hero;
